import React, { useCallback } from "react";
import { Dropdown } from "semantic-ui-react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  fetchAdditionalCityFences,
  removeAddtionalCityGeofences
} from "../../../../redux/geofence/actions";
const getDropdownOptions = cities =>
  cities.map((cityName, index) => ({
    key: index,
    text: cityName,
    value: cityName
  }));

const diffArr = (arr1, arr2) => arr1.filter(x => !arr2.includes(x));

const AdditionalCityMultiSelector = () => {
  const dispatch = useDispatch();
  const availableCities = useSelector(
    ({ geofence }) =>
      geofence.availableCities
        ? geofence.availableCities.filter(e => e !== geofence.currentCityName)
        : [],
    shallowEqual
  );
  const currentAdditionalCities = useSelector(({ geofence }) =>
    geofence.additionalGeofences
      ? Object.keys(geofence.additionalGeofences)
      : []
  );
  const updateStore = useCallback(
    newAddtionalCitiesValue => {
      const newCities = diffArr(
        newAddtionalCitiesValue,
        currentAdditionalCities
      );
      if (newCities.length > 0) {
        dispatch(fetchAdditionalCityFences(newCities));
        return;
      }
      const removedCities = diffArr(
        currentAdditionalCities,
        newAddtionalCitiesValue
      );
      if (removedCities.length > 0) {
        dispatch(removeAddtionalCityGeofences(removedCities));
      }
    },
    [dispatch, currentAdditionalCities]
  );
  return (
    <Dropdown
      className="AdditionalCityMultiSelector"
      placeholder="View More City Fences"
      multiple
      search
      selection
      value={currentAdditionalCities}
      onChange={(_, { value }) => updateStore(value)}
      options={
        getDropdownOptions(availableCities) || [
          {
            text: "Loading..."
          }
        ]
      }
    />
  );
};

export default AdditionalCityMultiSelector;
